export { default as AddToBag } from './AddToBag'



// WEBPACK FOOTER //
// ./src/components/addToBag/index.js